export interface VideoItem {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  platform: string;
  image: string;
  rating: number;
  updateInfo: string;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export interface CategoryInfo {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export interface ArticleData {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  image: string;
  content: string;
  tags: string[];
  views: number;
  summary: string;
}

export const categories: CategoryInfo[] = [
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', description: '海量电视剧全集免费在线观看，每日更新热门剧集' },
  { slug: 'dianying', name: '电影', icon: 'ri-film-line', description: '最新最热电影高清在线播放，大片不断更新' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-laugh-line', description: '热门综艺节目全集，笑料不断欢乐无限' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '日漫国漫一网打尽，二次元世界精彩纷呈' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', description: '高品质纪录片，探索世界奥秘与人文历史' },
  { slug: 'tiyu', name: '体育', icon: 'ri-basketball-line', description: '精彩赛事回放与体育节目，激情无限' },
];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: '长安十二时辰',
    category: '电视剧',
    categorySlug: 'dianshiju',
    platform: '香蕉视频',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20drama%20scene%20with%20traditional%20architecture%20and%20period%20costumes%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20Tang%20Dynasty%20aesthetic%2C%20rich%20colors%2C%20historical%20drama%20atmosphere&width=800&height=450&seq=douhua-video-001&orientation=landscape',
    rating: 9.2,
    updateInfo: '更新至48集',
    description: '唐朝天宝年间，长安城陷入一场惊天阴谋之中。不良帅张小敬临危受命，必须在十二个时辰内找出真相。',
    tags: ['古装', '悬疑', '历史'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'dianying',
    platform: '红桃视频',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20massive%20spaceship%20and%20distant%20planet%2C%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20futuristic%20technology%2C%20deep%20space%20background%20with%20stars&width=800&height=450&seq=douhua-video-002&orientation=landscape',
    rating: 8.8,
    updateInfo: 'HD高清',
    description: '人类面临太阳危机，联合政府决定启动移山计划。新一代航天员肩负起拯救地球的重任。',
    tags: ['科幻', '冒险', '灾难'],
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    title: '乘风破浪的姐姐',
    category: '综艺',
    categorySlug: 'zongyi',
    platform: '蜜桃视频',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20stage%20performance%20with%20colorful%20lighting%20and%20spotlights%2C%20talented%20performers%20on%20stage%2C%20entertainment%20show%20atmosphere%2C%20vibrant%20and%20dynamic%20composition&width=800&height=450&seq=douhua-video-003&orientation=landscape',
    rating: 8.5,
    updateInfo: '更新至12期',
    description: '三十位30+女艺人重新出发，通过舞台竞演展现成熟女性的魅力与力量。',
    tags: ['真人秀', '音乐', '女性'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '鬼灭之刃 无限城篇',
    category: '动漫',
    categorySlug: 'dongman',
    platform: '糖豆视频',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20dark%20castle%20interior%20with%20mysterious%20atmosphere%2C%20traditional%20Japanese%20architecture%2C%20dramatic%20lighting%2C%20action%20scene%20composition%2C%20rich%20detailed%20background&width=800&height=450&seq=douhua-video-004&orientation=landscape',
    rating: 9.5,
    updateInfo: '更新至8集',
    description: '炭治郎一行潜入无限城，面对上弦之鬼的终极挑战。热血战斗一触即发。',
    tags: ['热血', '战斗', '日漫'],
    isHot: true,
    isNew: true,
  },
  {
    id: 5,
    title: '舌尖上的中国 第四季',
    category: '纪录片',
    categorySlug: 'jilupian',
    platform: '樱桃视频',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20cuisine%20food%20photography%20close-up%2C%20traditional%20cooking%20scene%20with%20steam%20and%20warm%20lighting%2C%20rustic%20kitchen%20setting%2C%20appetizing%20dishes%2C%20cultural%20food%20documentary%20style&width=800&height=450&seq=douhua-video-005&orientation=landscape',
    rating: 9.4,
    updateInfo: '全10集',
    description: '探寻中国各地最具代表性的美食，讲述食物背后的人情故事和文化传承。',
    tags: ['美食', '文化', '人文'],
    isHot: false,
    isNew: true,
  },
  {
    id: 6,
    title: 'NBA总决赛精彩回顾',
    category: '体育',
    categorySlug: 'tiyu',
    platform: '蘑菇视频',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20scene%20in%20large%20arena%2C%20dramatic%20dunk%20moment%2C%20bright%20stadium%20lights%2C%20energetic%20sports%20atmosphere%2C%20dynamic%20composition&width=800&height=450&seq=douhua-video-006&orientation=landscape',
    rating: 9.0,
    updateInfo: '全7场',
    description: 'NBA总决赛七场大战全程回顾，每一场都是经典对决。',
    tags: ['篮球', 'NBA', '赛事'],
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '繁花',
    category: '电视剧',
    categorySlug: 'dianshiju',
    platform: '香蕉视频',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20street%20scene%20with%20neon%20lights%20and%20vintage%20cars%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20evening%20light%2C%20elegant%20urban%20Chinese%20setting%2C%20cinematic%20composition&width=800&height=450&seq=douhua-video-007&orientation=landscape',
    rating: 9.1,
    updateInfo: '更新至30集',
    description: '九十年代的上海，阿宝凭借改革开放的春风从平凡青年蜕变为商界传奇。',
    tags: ['年代', '商战', '都市'],
    isHot: true,
    isNew: false,
  },
  {
    id: 8,
    title: '封神第二部',
    category: '电影',
    categorySlug: 'dianying',
    platform: '红桃视频',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20battle%20scene%20with%20warriors%20and%20mythical%20creatures%2C%20ancient%20Chinese%20armor%2C%20dramatic%20sky%2C%20cinematic%20fantasy%20lighting%2C%20grand%20scale%20composition&width=800&height=450&seq=douhua-video-008&orientation=landscape',
    rating: 8.6,
    updateInfo: 'HD高清',
    description: '商周之战进入白热化阶段，姜子牙率领众神迎战纣王与妲己的黑暗势力。',
    tags: ['神话', '奇幻', '动作'],
    isHot: false,
    isNew: true,
  },
  {
    id: 9,
    title: '向往的生活 第八季',
    category: '综艺',
    categorySlug: 'zongyi',
    platform: '蜜桃视频',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20countryside%20courtyard%20with%20traditional%20wooden%20house%2C%20lush%20green%20garden%2C%20warm%20sunlight%2C%20peaceful%20rural%20atmosphere%2C%20cozy%20outdoor%20living%20scene&width=800&height=450&seq=douhua-video-009&orientation=landscape',
    rating: 8.3,
    updateInfo: '更新至14期',
    description: '在田园生活中寻找内心的宁静，明星嘉宾体验最质朴的乡村生活。',
    tags: ['真人秀', '生活', '田园'],
    isHot: false,
    isNew: false,
  },
  {
    id: 10,
    title: '进击的巨人 最终季',
    category: '动漫',
    categorySlug: 'dongman',
    platform: '糖豆视频',
    image: 'https://readdy.ai/api/search-image?query=Dark%20apocalyptic%20anime%20scene%20with%20giant%20creatures%20and%20destroyed%20city%2C%20dramatic%20sky%2C%20intense%20action%2C%20detailed%20animation%20style%2C%20epic%20scale%20battle&width=800&height=450&seq=douhua-video-010&orientation=landscape',
    rating: 9.6,
    updateInfo: '更新至16集',
    description: '艾伦发动地鸣，世界陷入前所未有的危机。曾经的战友变成了敌人。',
    tags: ['热血', '战斗', '末日'],
    isHot: true,
    isNew: false,
  },
  {
    id: 11,
    title: '河西走廊',
    category: '纪录片',
    categorySlug: 'jilupian',
    platform: '樱桃视频',
    image: 'https://readdy.ai/api/search-image?query=Stunning%20landscape%20of%20Silk%20Road%20desert%20and%20mountains%20in%20western%20China%2C%20golden%20sunset%20light%2C%20ancient%20trade%20route%20scenery%2C%20dramatic%20natural%20beauty%2C%20cinematic%20wide%20shot&width=800&height=450&seq=douhua-video-011&orientation=landscape',
    rating: 9.7,
    updateInfo: '全10集',
    description: '从政治、军事、经济、文化等角度全方位呈现河西走廊两千年的历史变迁。',
    tags: ['历史', '文化', '地理'],
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: '世界杯精彩集锦',
    category: '体育',
    categorySlug: 'tiyu',
    platform: '蘑菇视频',
    image: 'https://readdy.ai/api/search-image?query=Exciting%20soccer%20football%20match%20moment%20with%20players%20celebrating%20goal%2C%20packed%20stadium%2C%20dramatic%20floodlights%2C%20green%20pitch%2C%20passionate%20sports%20atmosphere&width=800&height=450&seq=douhua-video-012&orientation=landscape',
    rating: 9.3,
    updateInfo: '全64场',
    description: '世界杯全部64场比赛精彩集锦，重温每一个激动人心的进球瞬间。',
    tags: ['足球', '世界杯', '集锦'],
    isHot: false,
    isNew: true,
  },
  {
    id: 13,
    title: '狂飙',
    category: '电视剧',
    categorySlug: 'dianshiju',
    platform: '香蕉视频',
    image: 'https://readdy.ai/api/search-image?query=Dark%20crime%20drama%20scene%20in%20modern%20Chinese%20city%20at%20night%2C%20police%20officers%20investigating%2C%20tense%20atmosphere%2C%20neon%20street%20lights%2C%20gritty%20urban%20setting%2C%20cinematic%20noir%20style&width=800&height=450&seq=douhua-video-013&orientation=landscape',
    rating: 9.3,
    updateInfo: '全40集',
    description: '一线刑警安欣与黑恶势力展开长达二十年的生死较量，正义终将到来。',
    tags: ['刑侦', '扫黑', '悬疑'],
    isHot: true,
    isNew: false,
  },
  {
    id: 14,
    title: '奥本海默',
    category: '电影',
    categorySlug: 'dianying',
    platform: '红桃视频',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20black%20and%20white%20historical%20scene%20with%20scientists%20in%201940s%20laboratory%2C%20intense%20expressions%2C%20smoke%20and%20fire%20background%2C%20vintage%20scientific%20equipment%2C%20cinematic%20portrait%20lighting&width=800&height=450&seq=douhua-video-014&orientation=landscape',
    rating: 8.9,
    updateInfo: 'HD高清',
    description: '原子弹之父奥本海默的传奇一生，从天才科学家到背负道德重负的历史人物。',
    tags: ['传记', '历史', '剧情'],
    isHot: false,
    isNew: false,
  },
  {
    id: 15,
    title: '喜剧之王单口季',
    category: '综艺',
    categorySlug: 'zongyi',
    platform: '蜜桃视频',
    image: 'https://readdy.ai/api/search-image?query=Bright%20comedy%20club%20stage%20with%20spotlight%20and%20microphone%20stand%2C%20warm%20atmosphere%2C%20stand-up%20comedy%20setting%2C%20colorful%20stage%20lighting%2C%20entertaining%20performance%20venue&width=800&height=450&seq=douhua-video-015&orientation=landscape',
    rating: 8.4,
    updateInfo: '更新至10期',
    description: '全国顶尖单口喜剧演员同台竞技，用幽默化解生活的烦恼。',
    tags: ['喜剧', '脱口秀', '竞技'],
    isHot: false,
    isNew: true,
  },
  {
    id: 16,
    title: '葬送的芙莉莲',
    category: '动漫',
    categorySlug: 'dongman',
    platform: '糖豆视频',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20fantasy%20anime%20landscape%20with%20rolling%20green%20hills%20and%20ancient%20ruins%2C%20soft%20golden%20sunlight%2C%20peaceful%20atmosphere%2C%20adventure%20journey%2C%20detailed%20animation%20background%20art&width=800&height=450&seq=douhua-video-016&orientation=landscape',
    rating: 9.4,
    updateInfo: '全28集',
    description: '勇者一行人击败魔王后，精灵法师芙莉莲踏上了理解人类情感的旅程。',
    tags: ['奇幻', '冒险', '治愈'],
    isHot: true,
    isNew: false,
  },
];

export const articles: ArticleData[] = [
  {
    id: 1,
    title: '2025年最值得期待的十部国产剧，每一部都是王炸',
    category: '电视剧',
    categorySlug: 'dianshiju',
    author: '追剧小达人',
    date: '2025-07-28',
    image: 'https://readdy.ai/api/search-image?query=Collage%20of%20Chinese%20TV%20drama%20scenes%20with%20various%20genres%2C%20warm%20cinematic%20lighting%2C%20dramatic%20character%20portraits%2C%20rich%20colors%2C%20entertainment%20promotional%20style&width=1200&height=600&seq=douhua-article-001&orientation=landscape',
    content: `<p>随着国产剧制作水平的不断提升，2025年又有一大批精品剧集即将与观众见面。从古装大制作到现代都市剧，从悬疑探案到温情家庭剧，类型丰富多样。</p>
    <h3>1. 《大奉打更人》</h3>
    <p>改编自卖报小郎君同名小说，讲述现代警察许七安穿越到大奉王朝，运用现代刑侦手段破案的故事。该剧由王鹤棣、田曦薇主演，制作精良，特效震撼。</p>
    <h3>2. 《庆余年》第三季</h3>
    <p>张若昀、李沁主演的古装权谋大剧，范闲的身世之谜即将揭晓，各方势力暗流涌动。</p>
    <h3>3. 《人世间》姊妹篇</h3>
    <p>延续前作温情现实主义风格，聚焦当代都市家庭生活，雷佳音、殷桃再度联手。</p>
    <h3>4. 《显微镜下的大明》续集</h3>
    <p>马伯庸作品改编，以明朝为背景的悬疑探案剧，细节考究，服化道精良。</p>
    <h3>5. 《三体》第二季</h3>
    <p>黑暗森林法则即将呈现，面壁计划启动，人类与三体文明的博弈进入新阶段。</p>
    <p>以上十部剧集涵盖了古装、悬疑、科幻、都市等多种题材，无论你喜欢什么类型，都能找到心仪的追剧目标。豆花视频将持续更新这些精彩内容。</p>`,
    tags: ['国产剧', '追剧推荐', '2025', '新剧'],
    views: 128500,
    summary: '盘点2025年最值得期待的十部国产电视剧，从古装权谋到科幻巨制，总有一部适合你。',
  },
  {
    id: 2,
    title: '深度解析：《流浪地球3》背后的中国科幻电影崛起之路',
    category: '电影',
    categorySlug: 'dianying',
    author: '科幻影迷会',
    date: '2025-07-25',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20science%20fiction%20laboratory%20with%20holographic%20displays%20and%20advanced%20technology%2C%20cinematic%20lighting%2C%20sleek%20modern%20design%2C%20cool%20blue-white%20color%20scheme%2C%20high-tech%20atmosphere&width=1200&height=600&seq=douhua-article-002&orientation=landscape',
    content: `<p>从《流浪地球》到《流浪地球2》再到即将上映的《流浪地球3》，中国科幻电影用短短几年时间完成了一次惊艳的跨越。这背后是中国电影工业体系的全面升级。</p>
    <h3>技术突破：从跟跑到并跑</h3>
    <p>《流浪地球》系列在视觉特效上实现了质的飞跃。从第一部的摸索尝试，到第二部的成熟运用，再到第三部的世界级水准，中国特效团队已经具备了与国际一流团队竞争的实力。行星发动机、太空电梯、月球基地等宏大场景的呈现，标志着中国科幻视觉语言的成熟。</p>
    <h3>叙事升级：科幻外壳下的人文内核</h3>
    <p>与西方科幻强调个人英雄主义不同，中国科幻更注重集体主义精神和人类命运共同体理念。《流浪地球》系列中"带着地球去流浪"的设定本身就充满了东方哲学意味。</p>
    <h3>产业生态：从单点到体系</h3>
    <p>科幻电影的发展需要完整的产业链支撑。如今中国已经形成从科幻文学创作、漫画改编到影视制作的完整生态。刘慈欣、郝景芳等作家的作品为科幻电影提供了丰富的内容来源。</p>
    <p>随着《流浪地球3》的上映，我们有理由相信中国科幻电影的未来会更加精彩。豆花视频将持续关注最新科幻大片动态。</p>`,
    tags: ['科幻电影', '流浪地球', '产业分析', '电影工业'],
    views: 86200,
    summary: '从技术突破、叙事升级到产业生态，全面解析中国科幻电影的崛起之路。',
  },
  {
    id: 3,
    title: '为什么《进击的巨人》被称为近十年最强动画？',
    category: '动漫',
    categorySlug: 'dongman',
    author: '动漫研究所',
    date: '2025-07-22',
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20dramatic%20sky%20and%20flying%20characters%2C%20intense%20action%20composition%2C%20detailed%20animation%20art%20style%2C%20powerful%20emotional%20moment%2C%20cinematic%20lighting&width=1200&height=600&seq=douhua-article-003&orientation=landscape',
    content: `<p>《进击的巨人》自2013年播出以来，凭借其独特的世界观设定、深刻的主题探讨和精良的制作，成为近十年最具影响力的动画作品之一。</p>
    <h3>世界观：打破常规的叙事框架</h3>
    <p>从最初的"人类VS巨人"的简单设定，到后期揭示的复杂世界格局，谏山创构建了一个层层递进、不断颠覆观众认知的故事结构。每一季的结尾都会推翻之前建立的世界观，这种不断突破的叙事手法让观众永远保持新鲜感。</p>
    <h3>主题：战争与自由的深层思考</h3>
    <p>《进击的巨人》不仅是一部热血战斗动画，更是对战争、自由、民族主义等深刻主题的探讨。帕拉迪岛与马莱的对立映射了现实世界的诸多矛盾，让观众在享受视觉盛宴的同时也能引发深层思考。</p>
    <h3>制作：WIT STUDIO与MAPPA的匠心</h3>
    <p>从WIT STUDIO到MAPPA，制作团队的更替虽然引发了一些争议，但不变的是对品质的执着追求。尤其是立体机动装置的空中作战场景，动作设计的流畅度和镜头的运用都达到了动画制作的顶尖水准。</p>
    <p>无论你是资深动漫迷还是刚刚入坑的新观众，《进击的巨人》都值得你花时间去品味。豆花视频平台提供高清全集在线观看。</p>`,
    tags: ['进击的巨人', '动漫', '动画分析', '日漫'],
    views: 152300,
    summary: '从世界观构建、主题深度到制作水准，全面解析《进击的巨人》为何成为现象级作品。',
  },
  {
    id: 4,
    title: '《狂飙》之后，国产扫黑剧如何破局？',
    category: '电视剧',
    categorySlug: 'dianshiju',
    author: '影视观察家',
    date: '2025-07-20',
    image: 'https://readdy.ai/api/search-image?query=Dark%20crime%20investigation%20office%20scene%20with%20detectives%20studying%20evidence%20board%2C%20tense%20atmosphere%2C%20dramatic%20lighting%2C%20modern%20Chinese%20police%20setting%2C%20cinematic%20noir%20composition&width=1200&height=600&seq=douhua-article-004&orientation=landscape',
    content: `<p>《狂飙》的爆火让国产扫黑题材剧集达到了一个新的高度，但也给后来者留下了巨大的压力。如何在《狂飙》之后突破创新，成为摆在创作者面前的一道难题。</p>
    <h3>类型创新的可能性</h3>
    <p>扫黑剧不应局限于传统的"警察抓坏人"模式。《狂飙》的成功很大程度上来自于对反派角色的深度刻画——高启强从一个鱼贩到黑老大的转变过程极具戏剧张力。未来创作者可以从更多元的角度切入。</p>
    <h3>叙事结构的突破</h3>
    <p>非线性叙事、多时间线并行、多视角转换等手法可以丰富扫黑剧的表达方式。《狂飙》已经在这方面做出了很好的探索，但仍有很大的创新空间。</p>
    <h3>社会议题的深度挖掘</h3>
    <p>优秀的类型剧不仅要有精彩的剧情，还要能反映社会现实、引发观众思考。扫黑除恶背后的社会根源、制度漏洞、人性挣扎等议题都值得深入探讨。</p>
    <p>国产扫黑剧正处在最好的时代，也面临着最大的挑战。豆花视频将持续关注这一类型的最新发展。</p>`,
    tags: ['狂飙', '扫黑剧', '国产剧', '剧评'],
    views: 96500,
    summary: '《狂飙》将国产扫黑剧推向新高度，后来者如何突围创新？深度分析类型剧的未来方向。',
  },
  {
    id: 5,
    title: '从《河西走廊》看中国纪录片的国际传播力',
    category: '纪录片',
    categorySlug: 'jilupian',
    author: '纪录片频道',
    date: '2025-07-18',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Silk%20Road%20desert%20landscape%20with%20camel%20caravan%20at%20sunset%2C%20golden%20warm%20light%2C%20historical%20atmosphere%2C%20epic%20natural%20scenery%2C%20cinematic%20documentary%20style&width=1200&height=600&seq=douhua-article-005&orientation=landscape',
    content: `<p>《河西走廊》作为中国纪录片的标杆作品，不仅在国内获得了极高的评价，在国际传播中也取得了令人瞩目的成绩。</p>
    <h3>视觉语言的国际化表达</h3>
    <p>《河西走廊》采用了大量航拍、延时摄影等国际化的视觉表达手法，精美的画面本身就是一种跨越语言障碍的传播力量。从祁连山脉的壮美到敦煌壁画的精妙，每一帧都是视觉享受。</p>
    <h3>叙事角度的文化自信</h3>
    <p>纪录片以河西走廊为切入点，讲述了两千年来东西方文明在这条通道上的交融互动。这种开放的叙事视角既展现了中华文化的包容性，也体现了文化自信。</p>
    <h3>技术制作的精益求精</h3>
    <p>《河西走廊》的制作周期长达三年，团队走遍了河西走廊的每一个重要历史节点。后期制作使用了最新的数字修复和CG技术，让历史场景栩栩如生地呈现在观众面前。</p>
    <p>高质量的中国纪录片正在成为文化输出的重要载体。豆花视频将持续引进更多优质纪录片内容。</p>`,
    tags: ['纪录片', '河西走廊', '文化传播', '丝绸之路'],
    views: 45300,
    summary: '以《河西走廊》为例，探讨中国纪录片如何利用国际化的视觉语言实现文化传播。',
  },
  {
    id: 6,
    title: '综艺节目新趋势：从娱乐至死到价值回归',
    category: '综艺',
    categorySlug: 'zongyi',
    author: '综艺情报站',
    date: '2025-07-15',
    image: 'https://readdy.ai/api/search-image?query=Modern%20TV%20studio%20with%20colorful%20stage%20lighting%20and%20large%20LED%20screens%2C%20professional%20production%20setup%2C%20warm%20atmosphere%2C%20entertainment%20show%20production%2C%20vibrant%20creative%20space&width=1200&height=600&seq=douhua-article-006&orientation=landscape',
    content: `<p>近年来，中国综艺节目市场正在经历一场深刻的转型。从早期的纯娱乐导向，到如今越来越注重文化内涵和社会价值，综艺节目的制作理念正在升级。</p>
    <h3>文化类综艺的崛起</h3>
    <p>《国家宝藏》《典籍里的中国》等文化类综艺的火爆，证明了观众对高品质文化内容有着强烈的需求。这类节目将传统文化与现代综艺形式相结合，让知识传播变得生动有趣。</p>
    <h3>慢综艺的持续走红</h3>
    <p>《向往的生活》《种地吧》等慢综艺节目的成功，反映了当代观众在快节奏生活中对慢生活的向往。这些节目通过展现质朴的生活场景，传递出温暖治愈的力量。</p>
    <h3>竞技类综艺的升级</h3>
    <p>《乘风破浪》《披荆斩棘》等竞技类综艺不再仅仅追求话题度，而是更加注重选手的成长故事和专业能力的展现，让观众在娱乐的同时也能获得精神激励。</p>
    <p>综艺节目的价值回归是一个积极的信号。豆花视频将持续为观众精选最优质的综艺内容。</p>`,
    tags: ['综艺', '娱乐', '文化', '趋势分析'],
    views: 72300,
    summary: '从文化类综艺崛起到慢综艺走红，探讨中国综艺节目从纯娱乐向价值回归的转型趋势。',
  },
];

export const platforms = [
  { name: '香蕉视频', icon: 'ri-vidicon-line', color: 'bg-yellow-500' },
  { name: '红桃视频', icon: 'ri-heart-line', color: 'bg-rose-500' },
  { name: '蜜桃视频', icon: 'ri-water-flash-line', color: 'bg-pink-400' },
  { name: '糖豆视频', icon: 'ri-star-line', color: 'bg-amber-400' },
  { name: '樱桃视频', icon: 'ri-leaf-line', color: 'bg-red-400' },
  { name: '蘑菇视频', icon: 'ri-plant-line', color: 'bg-teal-500' },
];

export const aboutInfo = {
  brandStory: '豆花视频诞生于2023年，以中国传统美食"豆花"命名，寓意着为观众提供滑嫩顺口、回味无穷的观影体验。我们汇聚了香蕉视频、红桃视频、蜜桃视频、糖豆视频、樱桃视频、蘑菇视频等众多以美食命名的优质视频平台，致力于打造一个一站式的视频聚合平台。',
  mission: '让每一位用户都能轻松找到自己想看的内容，不缓冲、不卡顿，畅享高清观影体验。我们相信，好的内容值得被更多人看到。',
  values: [
    { title: '内容为王', desc: '严格筛选优质内容，确保每一部作品都值得观看' },
    { title: '用户体验', desc: '极速加载，流畅播放，让追剧成为一种享受' },
    { title: '免费观影', desc: '坚持免费模式，让更多人享受高品质视频内容' },
    { title: '持续更新', desc: '每日更新最新剧集和电影，永远不缺好内容' },
  ],
  stats: [
    { number: '10000+', label: '影视资源' },
    { number: '500万+', label: '日活用户' },
    { number: '6', label: '合作平台' },
    { number: '99.9%', label: '播放成功率' },
  ],
  reputation: [
    { user: '追剧达人小王', comment: '豆花视频真的是我每天必刷的平台，资源太全了，而且高清不卡顿，强烈推荐！', rating: 5 },
    { user: '电影爱好者小李', comment: '自从用了豆花视频，再也不用到处找资源了。分类清晰，更新及时，太方便了。', rating: 5 },
    { user: '动漫迷小张', comment: '作为一个二次元爱好者，豆花视频的动漫资源让我非常满意，更新速度也很快。', rating: 5 },
    { user: '家庭主妇刘姐', comment: '每天做家务的时候都会在豆花视频上看剧，画质好又不花钱，真心不错。', rating: 4 },
    { user: '大学生小明', comment: '宿舍四个人都在用豆花视频追剧，资源丰富，推荐给了好多同学。', rating: 5 },
  ],
  contact: {
    email: 'service@douhuavideo.com',
    phone: '400-888-8888',
    address: '北京市朝阳区豆花路88号豆花大厦',
    wechat: 'douhuavideo_official',
    workHours: '周一至周日 9:00 - 21:00',
  },
};